import { Component } from "react";

// Termly is the cookie-consent manager. It draws its own banner and persists the
// visitor's choice (in localStorage), so the banner should appear once per browser
// rather than on every login. This component just loads the Termly script once.
const TERMLY_SRC =
    "https://app.termly.io/resource-blocker/aa1e0701-e7c1-42a4-b440-6fa8533f3c09?autoBlock=off";

class CookieConsentModal extends Component {
    componentDidMount() {
        // Avoid injecting the script more than once (login page can mount repeatedly).
        if (document.querySelector('script[data-termly="true"]')) {
            return;
        }
        const script = document.createElement("script");
        script.src = TERMLY_SRC;
        script.type = "text/javascript";
        script.async = true;
        script.setAttribute("data-termly", "true");
        document.head.appendChild(script);
    }

    render() {
        // Termly renders its own banner; nothing to render here.
        return null;
    }
}

export default CookieConsentModal;



// WEBPACK FOOTER //
// src/my-jeeva/login/CookieConsentModal.js